import { ServiceRequest } from "../types/service.type";
import { ServiceRequestStatusEnum, ServiceRequestTypeEnum } from "../enum/service.enum";

export const useServiceStatusFlags = (serviceRequest: ServiceRequest) => {
  const { status, type, contractId } = serviceRequest;

  return {
    isProvider: type === ServiceRequestTypeEnum.received,
    hasContract: Boolean(contractId),
    isCompleted: status === ServiceRequestStatusEnum.Completed,
    isContracted: status === ServiceRequestStatusEnum.Contracted,
    isCanceled: status === ServiceRequestStatusEnum.Canceled,
    isRejected: status === ServiceRequestStatusEnum.Rejected,
    isInitiated: status === ServiceRequestStatusEnum.Initiate,
    isNegotiated: status === ServiceRequestStatusEnum.Negotiated,
  };
};
